import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setBusqueda } from '../../actions/articulos'
import {
  getImagenesFamilias,
  getMenuFamilias,
  setFamiliaSeleccionada,
  unsetFamiliaSeleccionada,
} from '../../actions/familias'
import { anadirFiltro, limpiarFiltros, limpiarFiltrosTexto } from '../../actions/filtros'
import { withRouter } from '../../helpers/funciones'


import '../../css/FamiliasMenu.css'
import MenuLateral from './MenuLateral'

export class FamiliasMenu extends Component {
  static propTypes = {
    familias: PropTypes.array.isRequired,
    filtros_aplicados: PropTypes.array.isRequired,
    limpiarFiltros: PropTypes.func.isRequired,
    setFamiliaSeleccionada: PropTypes.func.isRequired,
    anadirFiltro: PropTypes.func.isRequired,
    usar_imagenes: PropTypes.bool,
    familia_seleccionada: PropTypes.object.isRequired,
    unsetFamiliaSeleccionada: PropTypes.func.isRequired,
    mostrar_titulo: PropTypes.bool,
  }

  componentDidMount() {
    if (this.props.familias === undefined || this.props.familias.length === 0) {
      this.props.getMenuFamilias()
    }

    if (this.props.usar_imagenes && this.props.usar_imagenes) {
      if (this.props.imagenes_familias === undefined || this.props.imagenes_familias.length === 0) {
        this.props.getImagenesFamilias()
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    window.wookie()
  }

  anadirFiltro = e => {
    let _estadistico = e.numero_tabla
    let _familia = e.codigo_familia
    let _nombre = e.descripcion

    this.props.limpiarFiltros()

    this.props.limpiarFiltrosTexto()

    this.props.setBusqueda('')

    this.props.setFamiliaSeleccionada(_estadistico, _familia, _nombre)

    this.props.anadirFiltro({
      estadistico: _estadistico,
      familia: _familia,
      nombre: _nombre,
      tipo: 'estad',
    })

    if (this.props.router && this.props.router.location.pathname !== '/articulos') {
      this.props.router.navigate('/articulos')
    }
  }

  onClick = e => {
    e.preventDefault()
    this.anadirFiltro(e)
  }

  onClickHijo = e => {
    e.preventDefault()
    this.anadirFiltro(e)
    window.cerrar_hijos(e.target.parentNode)
  }

  preventClick(e) {
    e.preventDefault()

    window.abrir_hijos(e.target.parentNode)
  }

  desplegarFamilias = e => {
    e.preventDefault()

    document.getElementsByClassName('familias-primer-nivel')[0].classList.toggle('visible')
  }

  pintarHijos(familia_padre) {
    var className_dropdown = ''
    var className_megamenu = ''
    if (familia_padre.nivel && familia_padre.nivel !== 1) {
      className_dropdown = 'dropdown-menu tt-nivel-' + (familia_padre.nivel - 1)
      className_megamenu = 'tt-megamenu-submenu tt-submenu-' + (familia_padre.nivel - 1)
    } else {
      className_dropdown = 'dropdown-menu'
      className_megamenu = 'tt-megamenu-submenu'
    }
    return (
      <div className={className_dropdown}>
        <div className='row tt-col-list'>
          <div className='col'>
            <ul className={className_megamenu}>
              {this.props.familias.map((hijo, hijo_index) => {
                if (hijo.codigo_padre === familia_padre.codigo_familia) {
                  return (
                    <li key={hijo_index}>
                      <a
                        href='/#'
                        data-familia={hijo.descripcion}
                        data-estadistico={hijo.numero_tabla}
                        data-codigo={hijo.codigo_familia}
                        onClick={this.onClickHijo}>
                        {hijo.descripcion}
                      </a>
                      {this.props.familias === undefined
                        ? ''
                        : this.props.familias
                            .filter(fam => fam.codigo_padre === hijo.codigo_familia)
                            .reduce((accumulator, currentValue) => accumulator + 1, 0) > 0
                        ? this.pintarHijos(hijo)
                        : ''}
                    </li>
                  )
                }
                return ''
              })}
            </ul>
          </div>
        </div>
      </div>
    )
  }

  limpiarFamilia = () => {
    const familia = this.props.familias.filter(
      elem => elem.codigo_familia === this.props.familia_seleccionada.codigo_familia,
    )[0]
    if (
      familia === undefined ||
      familia === null ||
      familia.codigo_padre === undefined ||
      familia.codigo_padre === null
    ) {
      this.props.unsetFamiliaSeleccionada()
      this.props.limpiarFiltros()
    } else {
      const familia_padre = this.props.familias.filter(
        elem => elem.codigo_familia === familia.codigo_padre,
      )[0]

      const e = {
        currentTarget: {
          dataset: {
            estadistico: familia_padre.numero_tabla,
            codigo: familia_padre.codigo_familia,
            familia: familia_padre.descripcion,
          },
        },
      }

      this.anadirFiltro(e)
    }
  }

  render() {
    if (this?.props?.familias !== undefined && this?.props?.familias !== null) {
      if (
        this.props.mostrar_titulo &&
        (this.props.familia_seleccionada.nombre !== undefined ||
          this.props.familia_seleccionada.nombre !== null)
      ) {
        return <h3>{this.props.familia_seleccionada.nombre}</h3>
      } else {
        return (
          <MenuLateral
            familias={this.props.familias}
            addFilter={this.anadirFiltro}></MenuLateral>
        )
      }
    } else {
      return <h1>No hay familias</h1>
    }
  }
}

const mapStateToProps = state => ({
  familias: state.familias.familias,
  filtros_aplicados: state.articulos.filtros_aplicados,
  imagenes_familias: state.familias.imagenes_familias,
  familia_seleccionada: state.familias.familia_seleccionada,
})

export default withRouter(
  connect(mapStateToProps, {
    limpiarFiltros,
    anadirFiltro,
    setBusqueda,
    setFamiliaSeleccionada,
    getImagenesFamilias,
    getMenuFamilias,
    unsetFamiliaSeleccionada,
    limpiarFiltrosTexto,
  })(FamiliasMenu),
)
